module.exports = __webpack_public_path__ + "static/img/bg-slight-production-oprema.9ed00d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/oprema/bg-slight-production-oprema.jpg
// module id = GMUZ
// module chunks = 1